import { render, staticRenderFns } from "./Minicomment.vue?vue&type=template&id=75804152&scoped=true&"
var script = {}
import style0 from "./Minicomment.vue?vue&type=style&index=0&id=75804152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75804152",
  null
  
)

export default component.exports